import { useTranslation } from 'react-i18next';
import { useHomeScreen } from '../contexts/HomeScreenContext';
import { Zap, Table, Check } from 'lucide-react';
import '../styles/home-screen-selector.css';
import { HomeScreenType } from '../utils/homeScreenPreference';

export function HomeScreenSelector() {
  const { t } = useTranslation();
  const { preference, setHomeScreen } = useHomeScreen();

  const screenOptions: Array<{
    value: HomeScreenType;
    label: string;
    icon: React.ReactNode;
    description: string;
  }> = [
    {
      value: 'charging-queue',
      label: t('homeScreen.queue', 'Charging Queue'),
      icon: <Zap size={24} />,
      description: t('homeScreen.queueDescription', 'Your charging sessions'),
    },
    {
      value: 'chargers-table',
      label: t('homeScreen.table', 'Chargers Table'),
      icon: <Table size={24} />,
      description: t('homeScreen.tableDescription', 'Detailed charger information'),
    },
  ];

  const handleSelectScreen = (screen: HomeScreenType) => {
    setHomeScreen(screen);
  };

  return (
    <div className="home-screen-selector">
      <div className="selector-header">
        <h3 className="selector-title">
          {t('homeScreen.title', 'Choose Your Home Screen')}
        </h3>
        <p className="selector-description">
          {t(
            'homeScreen.selectDescription',
            'This screen will appear when you open the app'
          )}
        </p>
      </div>

      <div className="screen-options">
        {screenOptions.map((option) => (
          <button
            key={option.value}
            className={`screen-option ${
              preference.screen === option.value ? 'selected' : ''
            }`}
            onClick={() => handleSelectScreen(option.value)}
            aria-pressed={preference.screen === option.value}
          >
            <div className="option-icon">{option.icon}</div>

            <div className="option-content">
              <h4 className="option-label">{option.label}</h4>
              <p className="option-description">{option.description}</p>
            </div>

            {preference.screen === option.value && (
              <div className="option-checkmark">
                <Check size={20} />
              </div>
            )}
          </button>
        ))}
      </div>

      <div className="selector-note">
        <p>
          {t(
            'homeScreen.note',
            'You can change this anytime in your profile settings.'
          )}
        </p>
      </div>
    </div>
  );
}
